// Set the countdown duration in seconds (e.g., 5 minutes = 300 seconds)
const countdownDuration = 600;

// Check if a saved countdown exists in localStorage
let countdownEnd = localStorage.getItem('countdownEnd');
if (!countdownEnd) {
    // If no countdown exists, set one based on the current time + duration
    countdownEnd = Date.now() + countdownDuration * 1000;
    localStorage.setItem('countdownEnd', countdownEnd);
}

// Update the timer every second
function updateTimer() {
    const now = Date.now();
    const timeLeft = countdownEnd - now;
    
    if (timeLeft <= 0) {
        document.getElementById('countdown-timer').innerText = 'Cart reservation has expired!';
        clearInterval(timerInterval);
        localStorage.removeItem('countdownEnd'); // Optionally remove the countdown when done
    } else {
        const minutes = Math.floor(timeLeft / 1000 / 60);
        const seconds = Math.floor((timeLeft / 1000) % 60);
        document.getElementById('countdown-timer').innerText = `Cart is reserved for ${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
    }
}

// Run the update function every second
const timerInterval = setInterval(updateTimer, 1000);